export default {
    props: {
        tag: {
            type: String,
            default: "div"
        },
        bgVariant: {
            type: String,
            default: null
        },
        borderVariant: {
            type: String,
            default: null
        },
        textVariant: {
            type: String,
            default: null
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/mixins/card-mixin.js
// module id = 104
// module chunks = 2